module.exports = __webpack_public_path__ + "static/media/35-web-or-mls-DSC06840.f825ad18.jpg";